import {EventContextComponent} from '@vista/omnichannel-components-ui'
import { EventDetailsPropsFromBe } from '../../types'
import { EventDetailsComponent as OccEventDetailsComponent } from '@vista/omnichannel-components-ui/lib/src/lib/components/event/'
import React from 'react'
import { eventDetailsProps } from './props'

export const EventDetailsComponent: React.FC<EventDetailsPropsFromBe & { scrollIntoView: () => void }> = (props) => {
    return (
        <EventContextComponent eventId={props.workflow.entityIds.eventId}>
            <OccEventDetailsComponent {...eventDetailsProps(props, props.scrollIntoView)} />
        </EventContextComponent>
    )
}

export default EventDetailsComponent
